import React, { useState, useEffect } from "react";
import { useAuth } from "../../AuthContext";

import api from "../../api";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import MenuItem from "@mui/material/MenuItem";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Divider from "@mui/material/Divider";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import AddCardRoundedIcon from "@mui/icons-material/AddCardRounded";
import CobrancaExtraDialog from "../../components/CobrancaExtraDialog";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

import FinancialUserDetails from "./FinancialUserDetails";
import ConfigurationManager from "../Configuration/ConfigurationManager";
import PaymentsAdmin from "./PaymentsAdmin";
import AdminDashboard from "./AdminDashboard";
import ArbitrosAdmin from "./ArbitrosAdmin";
import GatewaysAdmin from "./GatewaysAdmin";
import LoadingState from "../../components/ui/LoadingState";
import PagamentosEquipe from "./PagamentosEquipe";
import AppLayout from "../../components/ui/AppLayout";
import PageHeader from "../../components/ui/PageHeader";
import SectionCard from "../../components/ui/SectionCard";
import StatCard from "../../components/ui/StatCard";
import PlayerAvatar from "../../components/ui/PlayerAvatar";
import AvatarInput from "../../components/AvatarInput";
import { formatCurrency } from "../../utils/image";

// Mapa (Leaflet) carregado só quando a aba Check-in é aberta, para não pesar o app dos jogadores
const CheckinLocalAdmin = React.lazy(() => import("./CheckinLocalAdmin"));
const CheckinNfcAdmin = React.lazy(() => import("./CheckinNfcAdmin"));

const operationLabels = {
  credit: "Crédito no caixa do clube",
  debit: "Débito no caixa do clube",
  revenue: "Receita de jogador (pagamento)",
  charge: "Cobrança para jogador",
  createDebitMensalAll: "Gerar mensalidades do mês",
};

// "Débito" (saída manual do caixa) só aparece para Admin.
const FinancialActions = ({ onOpen, includeMonthly, podeDebitar, onCobrancaExtra }) => (
  <>
    <Button size="small" variant="outlined" onClick={() => onOpen("credit")}>Crédito</Button>
    {podeDebitar && <Button size="small" variant="outlined" onClick={() => onOpen("debit")}>Débito</Button>}
    <Button size="small" variant="outlined" onClick={() => onOpen("revenue")}>Receita</Button>
    <Button size="small" variant="outlined" onClick={() => onOpen("charge")}>Cobrança</Button>
    {includeMonthly && (
      <Button size="small" variant="contained" startIcon={<CalendarMonthRoundedIcon />} onClick={() => onOpen("createDebitMensalAll")}>
        Gerar mensalidades
      </Button>
    )}
    {onCobrancaExtra && (
      <Button size="small" variant="outlined" startIcon={<AddCardRoundedIcon />} onClick={onCobrancaExtra}>
        Cobrança extra
      </Button>
    )}
  </>
);

const Aprove = () => {
  const { isAuthenticated, userLogado } = useAuth();
  const ehAdmin = userLogado?.perfil === "Admin";
  const [tabIndex, setTabIndex] = useState(0);
  const [cobrancaExtraAberta, setCobrancaExtraAberta] = useState(false);

  const [userSelect, setUserSelect] = useState("");
  const [perfil, setPerfil] = useState("");
  const [typePlayer, setTypePlayer] = useState("");
  const [nome, setNome] = useState("");
  const [nickName, setNickName] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [email, setEmail] = useState("");
  const [torre, setTorre] = useState("");
  const [apartamento, setApartamento] = useState("");
  const [status, setStatus] = useState("");
  const [isento, setIsento] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [financialDialogOpen, setFinancialDialogOpen] = useState(false);
  const [financialOperation, setFinancialOperation] = useState("");
  const [financialParams, setFinancialParams] = useState({});
  const [severity, setSeverity] = useState("success");
  const [openMessage, setOpenMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [rows, setRows] = useState([]);
  const [users, setUsers] = useState([]);

  const [financialData, setFinancialData] = useState([]);
  const [balance, setBalance] = useState(0);

  const [defaulters, setDefaulters] = useState([]);
  const [previewMessage, setPreviewMessage] = useState("");
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [search, setSearch] = useState("");

  const notify = (text, type = "success") => {
    setMessage(text);
    setSeverity(type);
    setOpenMessage(true);
  };

  const getDefaulters = async () => {
    try {
      const response = await api.get("getDefaulter");
      if (response.data.success) {
        setDefaulters(response.data.players);
      } else {
        setMessage("Erro ao obter jogadores devedores");
        setSeverity("error");
        setOpenMessage(true);
      }
    } catch (error) {
      console.error("Erro ao obter jogadores devedores:", error);
      setMessage("Erro ao obter jogadores devedores");
      setSeverity("error");
      setOpenMessage(true);
    }
  };

  const formatWhatsAppMessage = () => {
    const message = defaulters
      .filter((player) => player.balance < 0 || player.balance > 0)
      .map((player) => `${player.userName}: R$ ${player.balance.toFixed(2)}`)
      .join("\n");
    setPreviewMessage(`Rivierafc.com.br \n Jogadores em atraso:\n\n${message}`);
    setPreviewDialogOpen(true);
  };

  const handleShare = () => {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
      previewMessage
    )}`;
    window.open(whatsappUrl, "_blank");
    setPreviewDialogOpen(false);
  };

  const getUsers = async () => {
    try {
      const response = await api.get("user/showAll");
      const usersData = response.data.map((item) => {
        const { _id, ...resto } = item;
        return {
          id: _id,
          ...resto,
          typePlayer: item.typePlayer === "M" ? "Mensalista" : "Diarista",
          isento: item.isento ? "Sim" : "Não",
        };
      });
      setRows(usersData);
      setUsers(usersData);
    } catch (error) {
      console.error("Erro ao obter jogadores:", error);
      return [];
    }
  };

  const getFinancialData = async () => {
    try {
      const response = await api.get("/getBalance");
      setBalance(response.data.saldo);
      setFinancialData(
        response.data.records.map((record) => ({
          ...record,
          amount: record.type === "debit" ? -record.amount : record.amount,
        }))
      );
    } catch (error) {
      console.error("Erro ao obter dados financeiros:", error);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  async function handleOpenUpdate(id) {
    const selectedUser = rows.find((row) => row.id === id);

    setUserSelect(selectedUser);
    setPerfil(selectedUser.perfil);
    setTypePlayer(selectedUser.typePlayer);
    setNome(selectedUser.nome);
    setNickName(selectedUser.nickName);
    setApartamento(selectedUser.apartamento);
    setTorre(selectedUser.torre);
    setStatus(selectedUser.status);
    setEmail(selectedUser.email);
    setIsento(selectedUser.isento === "Sim");
    setDialogOpen(true);
  }

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleCloseFinancialDialog = () => {
    setFinancialDialogOpen(false);
  };

  async function handleOpenApprove(id) {
    const selectedUser = rows.find((row) => row.id === id);
    setUserSelect(selectedUser);
    setConfirmDialogOpen(true);
  }

  const handleCloseConfirm = () => {
    setConfirmDialogOpen(false);
  };

  const handleConfirmApproveUser = async () => {
    try {
      const body = { user_id: userSelect.id };
      const response = await api.post("user/aprove", body);
      if (response.status === 200) {
        setConfirmDialogOpen(false);
        setMessage("Usuário Aprovado.");
        setSeverity("success");
        setOpenMessage(true);
        getUsers();
      } else {
        setMessage(response.data.error);
        setSeverity("error");
        setOpenMessage(true);
      }
    } catch (error) {
      console.error("Erro ao Aprovar", error);
      setMessage(error.response?.data?.error || "Ocorreu um erro");
      setSeverity("error");
      setOpenMessage(true);
    }
  };

  const updateUser = async () => {
    try {
      const body = {
        user_id: userSelect.id,
        perfil,
        typePlayer: typePlayer === "Mensalista" ? "M" : "D",
        isento,
        apartamento,
        email,
        status,
        torre,
        nome,
        nickName,
      };
      const response = await api.put("/updateForAdmin", body);
      if (response.data.success) {
        setMessage("Usuário atualizado com sucesso.");
        setSeverity("success");
        setOpenMessage(true);
        getUsers();
        handleClose();
      } else {
        setMessage(response.data.error);
        setSeverity("error");
        setOpenMessage(true);
      }
    } catch (error) {
      console.error("Erro ao atualizar usuário:", error);
      setMessage("Erro ao atualizar usuário");
      setSeverity("error");
      setOpenMessage(true);
    }
  };

  const handleDeleteUser = (id) => {
    const selectedUser = rows.find((row) => row.id === id);
    setUserSelect(selectedUser);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDeleteUser = async () => {
    const body = {
      user_id: userSelect.id,
    };
    try {
      const response = await api.post(`/user/delete/`, body);
      if (response.status === 200) {
        setDeleteDialogOpen(false);
        setMessage("Usuário Excluído.");
        setSeverity("success");
        setOpenMessage(true);
        getUsers();
      } else {
        setMessage(response.data.error);
        setSeverity("error");
        setOpenMessage(true);
      }
    } catch (error) {
      console.error("Erro ao Excluir", error);
      setMessage(error.response?.data?.error || "Ocorreu um erro");
      setSeverity("error");
      setOpenMessage(true);
    }
  };

  const handleOpenFinancialDialog = (operation) => {
    setFinancialOperation(operation);
    setFinancialDialogOpen(true);
  };

  const handleConfirmFinancialOperation = async () => {
    let url = "";
    let body = {};
    if (financialOperation === "debit") {
      url = "/createDebit";
      body = {
        description: financialParams.description,
        amount: financialParams.amount,
      };
    } else if (financialOperation === "revenue") {
      url = "/createRevenue";
      body = {
        user: financialParams.user.id,
        description: financialParams.description,
        amount: financialParams.amount,
      };
    } else if (financialOperation === "charge") {
      url = "/createCharge";
      body = {
        user: financialParams.user.id,
        description: financialParams.description,
        amount: financialParams.amount,
      };
    } else if (financialOperation === "credit") {
      url = "/createCredit";
      body = {
        description: financialParams.description,
        amount: financialParams.amount,
        type: "credit",
      };
    } else if (financialOperation === "createDebitMensalAll") {
      url = "/createDebitMensalAll";
    }

    try {
      const response = await api.post(url, body);
      if (response.status === 200 || response.data.success) {
        setFinancialDialogOpen(false);

        setMessage("Operação realizada com sucesso.");
        setSeverity("success");
        setOpenMessage(true);
        await getFinancialData();
      } else {
        setMessage(response.data.error);
        setSeverity("error");
        setOpenMessage(true);
      }
    } catch (error) {
      console.error("Erro ao realizar operação financeira", error);
      setMessage(error.response?.data?.error || "Ocorreu um erro");
      setSeverity("error");
      setOpenMessage(true);
    }
  };

  const columns = [
    {
      field: "foto",
      headerName: "",
      width: 60,
      sortable: false,
      renderCell: (params) => <PlayerAvatar src={params.row.foto} name={params.row.nome} size={34} />,
    },
    { field: "nome", headerName: "Nome", flex: 1, minWidth: 220 },
    { field: "email", headerName: "Email", flex: 1, minWidth: 200 },
    { field: "torre", headerName: "Torre", width: 90 },
    { field: "apartamento", headerName: "Apto", width: 80 },
    { field: "typePlayer", headerName: "Tipo", width: 110 },
    { field: "isento", headerName: "Isento", width: 80 },
    {
      field: "status",
      headerName: "Status",
      width: 110,
      renderCell: (params) => (
        <Chip size="small" label={params.value} color={params.value === "Ativo" ? "success" : params.value === "Pendente" ? "warning" : "default"} variant="outlined" />
      ),
    },
    { field: "perfil", headerName: "Perfil", width: 90 },
    {
      field: "acoes",
      headerName: "Ações",
      width: 140,
      sortable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="Editar">
            <IconButton size="small" onClick={() => handleOpenUpdate(params.row.id)}>
              <EditIcon fontSize="small" color="primary" />
            </IconButton>
          </Tooltip>
          {params.row.status === "Pendente" && (
            <Tooltip title="Aprovar">
              <IconButton size="small" onClick={() => handleOpenApprove(params.row.id)}>
                <CheckCircleIcon fontSize="small" color="success" />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="Excluir">
            <IconButton size="small" onClick={() => handleDeleteUser(params.row.id)}>
              <DeleteIcon fontSize="small" color="error" />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const financialColumns = [
    { field: "description", headerName: "Descrição", flex: 1, minWidth: 220 },
    {
      field: "amount",
      headerName: "Valor",
      width: 130,
      type: "number",
      renderCell: (params) => {
        const amount = params.row.amount;
        const formattedAmount = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(amount);
        return <span style={{ color: amount < 0 ? "#C62828" : "#1F9D55", fontWeight: 600 }}>{formattedAmount}</span>;
      },
    },
    { field: "userName", headerName: "Usuário", width: 200 },
    { field: "createdAt", headerName: "Data e hora", width: 180, valueFormatter: (params) => (params.value ? new Date(params.value).toLocaleString("pt-BR") : "") },
  ];

  useEffect(() => {
    getUsers();
    getFinancialData();
    getDefaulters();
  }, []);

  const pendentes = rows.filter((row) => row.status === "Pendente").length;
  const termo = search.trim().toLowerCase();
  const filteredRows = termo
    ? rows.filter((row) => [row.nome, row.email, row.apartamento, row.nickName].some((v) => String(v || "").toLowerCase().includes(termo)))
    : rows;
  const devedores = defaulters.filter((player) => player.balance < 0);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <AppLayout maxWidth="xl">
      <PageHeader eyebrow="Diretoria" title="Administração" subtitle="Usuários, financeiro do clube, mensalidades e configurações." />

      <Card sx={{ mb: 3 }}>
        <Tabs value={tabIndex} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
          <Tab label="Dashboard" />
          <Tab label={pendentes > 0 ? `Usuários (${pendentes} pendentes)` : "Usuários"} />
          <Tab label="Financeiro do clube" />
          <Tab label="Extrato por jogador" />
          <Tab label="Pagamentos PIX" />
          <Tab label="Árbitros e goleiros" />
          <Tab label="Configurações" />
          <Tab label="Gateways e taxas" />
          <Tab label="Check-in" />
        </Tabs>
      </Card>

      {tabIndex === 0 && <AdminDashboard onMessage={notify} onGoTab={setTabIndex} />}

      {tabIndex === 7 && <GatewaysAdmin onMessage={notify} />}

      {tabIndex === 8 && (
        <React.Suspense fallback={<LoadingState label="Carregando mapa..." />}>
          <Stack spacing={3}>
            <CheckinLocalAdmin onMessage={notify} />
            <CheckinNfcAdmin onMessage={notify} />
          </Stack>
        </React.Suspense>
      )}

      {tabIndex === 5 && (
        <Stack spacing={3}>
          <SectionCard title="Goleiros" subtitle="Login para o check-in na pelada, valor por pelada e vínculo fixo">
            <ArbitrosAdmin papel="goleiro" onMessage={notify} />
          </SectionCard>
          <SectionCard title="Árbitros" subtitle="Login para operar as partidas após o check-in, valor por pelada e vínculo fixo">
            <ArbitrosAdmin papel="arbitro" onMessage={notify} />
          </SectionCard>
        </Stack>
      )}

      {tabIndex === 1 && (
        <SectionCard
          title="Usuários"
          subtitle={`${rows.length} cadastrados`}
          actions={
            <TextField
              size="small"
              placeholder="Buscar por nome, e-mail ou apto"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{ startAdornment: <InputAdornment position="start"><SearchRoundedIcon fontSize="small" /></InputAdornment> }}
              sx={{ minWidth: 280 }}
            />
          }
        >
          <DataGrid
            rows={filteredRows}
            columns={columns}
            autoHeight
            disableRowSelectionOnClick
            initialState={{ pagination: { paginationModel: { pageSize: 10 } }, sorting: { sortModel: [{ field: "status", sort: "desc" }] } }}
            pageSizeOptions={[10, 25, 50]}
            onRowClick={(newRowSelectionModel) => setRowSelectionModel(newRowSelectionModel)}
          />
        </SectionCard>
      )}

      {tabIndex === 2 && (
        <Stack spacing={3}>
          <PagamentosEquipe onMessage={notify} onAtualizarCaixa={getFinancialData} />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <StatCard label="Saldo do clube" value={formatCurrency(balance)} icon={<AccountBalanceWalletRoundedIcon />} tone={balance < 0 ? "danger" : "success"} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <StatCard label="Jogadores em atraso" value={devedores.length} hint={formatCurrency(devedores.reduce((t, p) => t + p.balance, 0))} icon={<AddCardRoundedIcon />} tone="gold" />
            </Grid>
          </Grid>
          <SectionCard
            title="Lançamentos do clube"
            actions={
              <>
                <FinancialActions onOpen={handleOpenFinancialDialog} includeMonthly podeDebitar={ehAdmin} onCobrancaExtra={() => setCobrancaExtraAberta(true)} />
                <Button size="small" variant="outlined" color="success" startIcon={<WhatsAppIcon />} onClick={formatWhatsAppMessage}>
                  Devedores
                </Button>
              </>
            }
          >
            <DataGrid
              rows={financialData.map((item, index) => ({ id: index, ...item }))}
              columns={financialColumns}
              autoHeight
              disableColumnMenu
              disableRowSelectionOnClick
              initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
              pageSizeOptions={[10, 25, 50]}
            />
          </SectionCard>
        </Stack>
      )}

      {tabIndex === 3 && (
        <SectionCard title="Extrato por jogador" subtitle="Cobranças e pagamentos lançados para cada jogador" actions={<FinancialActions onOpen={handleOpenFinancialDialog} podeDebitar={ehAdmin} />}>
          <FinancialUserDetails />
        </SectionCard>
      )}

      {tabIndex === 4 && (
        <SectionCard title="Pagamentos PIX" subtitle="Mensalidades pagas online (Asaas / Mercado Pago) com baixa automática via webhook">
          <PaymentsAdmin onMessage={notify} />
        </SectionCard>
      )}

      {tabIndex === 6 && (
        <SectionCard title="Configurações">
          <ConfigurationManager />
        </SectionCard>
      )}

      <Dialog open={previewDialogOpen} onClose={() => setPreviewDialogOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Mensagem para o WhatsApp</DialogTitle>
        <DialogContent>
          <TextField value={previewMessage} onChange={(e) => setPreviewMessage(e.target.value)} multiline minRows={8} fullWidth />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setPreviewDialogOpen(false)} color="inherit">Cancelar</Button>
          <Button onClick={handleShare} variant="contained" color="success" startIcon={<WhatsAppIcon />}>Compartilhar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dialogOpen} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Editar usuário</DialogTitle>
        <DialogContent>
          <Stack alignItems="center" sx={{ mb: 3, mt: 1 }}>
            <AvatarInput
              src={userSelect.foto}
              name={userSelect.nome}
              userId={userSelect.id}
              size={96}
              onChange={(user) => {
                setUserSelect({ ...userSelect, foto: user.foto });
                setRows((atual) => atual.map((row) => (row.id === userSelect.id ? { ...row, foto: user.foto } : row)));
                notify(user.foto ? "Foto atualizada." : "Foto removida.");
              }}
              onError={(text) => notify(text, "error")}
            />
          </Stack>
          <Divider sx={{ mb: 3 }} />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={8}><TextField label="Nome" value={nome} onChange={(e) => setNome(e.target.value)} fullWidth /></Grid>
            <Grid item xs={12} sm={4}><TextField label="Apelido" value={nickName} onChange={(e) => setNickName(e.target.value)} fullWidth /></Grid>
            <Grid item xs={12}><TextField label="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth /></Grid>
            <Grid item xs={6}>
              <TextField select label="Torre" value={torre || ""} onChange={(e) => setTorre(e.target.value)} fullWidth>
                <MenuItem value="Acqua">Acqua</MenuItem>
                <MenuItem value="Natura">Natura</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={6}><TextField label="Apartamento" value={apartamento} onChange={(e) => setApartamento(e.target.value)} fullWidth /></Grid>
            <Grid item xs={6}>
              <TextField select label="Status" value={status || ""} onChange={(e) => setStatus(e.target.value)} fullWidth>
                <MenuItem value="Ativo">Ativo</MenuItem>
                <MenuItem value="Pendente">Pendente</MenuItem>
                <MenuItem value="Inativo">Inativo</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField select label="Perfil" value={perfil || ""} onChange={(e) => setPerfil(e.target.value)} fullWidth>
                <MenuItem value="User">Jogador</MenuItem>
                <MenuItem value="Diretor">Diretor</MenuItem>
                <MenuItem value="Admin">Admin</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField select label="Tipo de jogador" value={typePlayer || ""} onChange={(e) => setTypePlayer(e.target.value)} fullWidth>
                <MenuItem value="Mensalista">Mensalista</MenuItem>
                <MenuItem value="Diarista">Diarista</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField select label="Isento de mensalidade" value={isento} onChange={(e) => setIsento(e.target.value)} fullWidth>
                <MenuItem value={true}>Sim</MenuItem>
                <MenuItem value={false}>Não</MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleClose} color="inherit">Cancelar</Button>
          <Button onClick={updateUser} variant="contained">Salvar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={confirmDialogOpen} onClose={handleCloseConfirm}>
        <DialogTitle>Aprovar usuário</DialogTitle>
        <DialogContent>
          <DialogContentText>Aprovar {userSelect.nome} como mensalista ativo? Ele receberá um e-mail de confirmação.</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseConfirm} color="inherit">Cancelar</Button>
          <Button onClick={handleConfirmApproveUser} variant="contained" color="success">Aprovar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Excluir usuário</DialogTitle>
        <DialogContent>
          <DialogContentText>Tem certeza de que deseja excluir {userSelect.nome}? Esta ação não pode ser desfeita.</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setDeleteDialogOpen(false)} color="inherit">Cancelar</Button>
          <Button onClick={handleConfirmDeleteUser} variant="contained" color="error">Excluir</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={financialDialogOpen} onClose={handleCloseFinancialDialog} fullWidth maxWidth="xs">
        <DialogTitle>{operationLabels[financialOperation] || "Operação financeira"}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ pt: 1 }}>
            {(financialOperation === "revenue" || financialOperation === "charge") && (
              <Autocomplete
                options={users}
                getOptionLabel={(option) => option.nome}
                value={financialParams.user || null}
                onChange={(event, newValue) => setFinancialParams({ ...financialParams, user: newValue })}
                renderInput={(params) => <TextField {...params} label="Jogador" />}
                fullWidth
              />
            )}
            {financialOperation !== "createDebitMensalAll" && (
              <>
                <TextField
                  label="Descrição"
                  value={financialParams.description || ""}
                  onChange={(e) => setFinancialParams({ ...financialParams, description: e.target.value })}
                  fullWidth
                />
                <TextField
                  label="Valor"
                  type="number"
                  value={financialParams.amount || ""}
                  onChange={(e) => setFinancialParams({ ...financialParams, amount: e.target.value })}
                  fullWidth
                  InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
                />
              </>
            )}
            {financialOperation === "createDebitMensalAll" && (
              <>
                <DialogContentText>
                  Será lançada a mensalidade para os mensalistas ativos (exceto isentos). Cada um recebe um e-mail com o link para pagar via PIX.
                </DialogContentText>
                <Stack direction="row" flexWrap="wrap" gap={0.75} sx={{ maxHeight: 220, overflowY: "auto" }}>
                  {users
                    .filter((user) => user.typePlayer === "Mensalista" && user.status === "Ativo" && user.isento !== "Sim")
                    .map((filteredUser) => (
                      <Chip key={filteredUser.id} size="small" label={filteredUser.nome} />
                    ))}
                </Stack>
              </>
            )}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseFinancialDialog} color="inherit">Cancelar</Button>
          <Button onClick={handleConfirmFinancialOperation} variant="contained">Confirmar</Button>
        </DialogActions>
      </Dialog>

      <CobrancaExtraDialog open={cobrancaExtraAberta} onClose={() => setCobrancaExtraAberta(false)} onConcluido={getFinancialData} onMessage={notify} />
      <Snackbar
        open={openMessage}
        autoHideDuration={6000}
        onClose={() => setOpenMessage(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MuiAlert onClose={() => setOpenMessage(false)} severity={severity} elevation={6} variant="filled">
          {message}
        </MuiAlert>
      </Snackbar>
    </AppLayout>
  );
};

export default Aprove;
